import { createAppAsyncThunk } from '../../store/extensions';
import { CreateTreatmentDto, UpdateTreatmentDto } from './dtos';
import {
  deleteTreatmentCall,
  fetchTreatmentsCall,
  insertTreatmentsCall,
  searchTreatmentsCall,
  updateTreatmentCall,
} from './service';

export const fetchTreatments = createAppAsyncThunk(
  'healthjourney/treatment/getAll',
  (healthjourneyId: string) => {
    return fetchTreatmentsCall(healthjourneyId);
  }
);

export const searchTreatments = createAppAsyncThunk(
  'healthjourney/treatment/searchTreatments',
  (searchString: string) => {
    return searchTreatmentsCall(searchString);
  }
);

export const insertTreatments = createAppAsyncThunk(
  'healthjourney/treatment/insert',
  (newTreatments: CreateTreatmentDto[]) => {
    return insertTreatmentsCall(newTreatments);
  }
);

export const updateTreatment = createAppAsyncThunk(
  'healthjourney/treatment/update',
  (treatment: UpdateTreatmentDto) => {
    return updateTreatmentCall(treatment);
  }
);

export const deleteTreatment = createAppAsyncThunk(
  'healthjourney/treatment/delete',
  (treatmentId: string) => {
    return deleteTreatmentCall(treatmentId);
  }
);
